import { ServerError } from '@types';

const parseServerErrors = (error: unknown): undefined | ServerError[] => {
  const errorCodes = (error as any)?.response?.data?.detail;

  return errorCodes;
};

export default parseServerErrors;
